import { createIconComponent } from '../../factory/create-icon-component';

export const ShirtIcon = createIconComponent(
  'ShirtIcon',
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9918 7.33398L11.9918 13.0317C11.9984 13.6306 11.6 14.1586 11.0223 14.3165C9.02836 14.7883 6.95184 14.7883 4.95791 14.3165C4.38016 14.1586 3.98176 13.6307 3.98836 13.0317L3.98842 7.33398"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0055 8.66749L14.1565 8.16082C14.3339 8.11902 14.4866 8.00639 14.5788 7.84914C14.6711 7.69189 14.6949 7.50372 14.6448 7.32842L13.8358 4.49685C13.6243 3.75662 13.1034 3.14384 12.4068 2.81598L11.2087 2.25206C10.8533 2.08478 10.4654 1.99805 10.0726 1.99805H5.92994C5.53715 1.99805 5.14921 2.08478 4.79382 2.25206L3.59571 2.81598C2.89916 3.14384 2.3782 3.75662 2.1667 4.49685L1.3577 7.32842C1.30761 7.50372 1.33147 7.69188 1.42372 7.84913C1.51597 8.00638 1.66858 8.11901 1.84603 8.16082L3.997 8.66749"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3327 2.01172V2.01172C10.3327 2.53886 10.1233 3.04441 9.75052 3.41715C9.37778 3.78989 8.87223 3.9993 8.34509 3.9993H7.65164C7.1245 3.9993 6.61896 3.78989 6.24621 3.41715C5.87347 3.04441 5.66406 2.53886 5.66406 2.01172V2.01172"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
